import { render, staticRenderFns } from "./SquarePictureFrame.vue?vue&type=template&id=7e62c163&scoped=true&"
import script from "./SquarePictureFrame.vue?vue&type=script&lang=js&"
export * from "./SquarePictureFrame.vue?vue&type=script&lang=js&"
import style0 from "./SquarePictureFrame.vue?vue&type=style&index=0&id=7e62c163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e62c163",
  null
  
)

export default component.exports